import { render } from "./CalcWeight.vue?vue&type=template&id=182dab23&ts=true"
import script from "./CalcWeight.vue?vue&type=script&lang=ts"
export * from "./CalcWeight.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__